/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Otp_Invalid_CodeInputs */

const en_us2_otp_invalid_code = /** @type {(inputs: Otp_Invalid_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That code is not correct. Check it and try again.`)
};

const pt_br2_otp_invalid_code = /** @type {(inputs: Otp_Invalid_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código incorreto. Confira e tente de novo.`)
};

const es_419_otp_invalid_code = /** @type {(inputs: Otp_Invalid_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código incorrecto. Revísalo e intenta de nuevo.`)
};

const pt_pt2_otp_invalid_code = /** @type {(inputs: Otp_Invalid_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código incorreto. Verifica-o e tenta outra vez.`)
};

const fr_fr2_otp_invalid_code = /** @type {(inputs: Otp_Invalid_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code incorrect. Vérifie-le et réessaie.`)
};

const de_de2_otp_invalid_code = /** @type {(inputs: Otp_Invalid_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Code ist falsch. Prüfe ihn und versuch es noch mal.`)
};

const it_it2_otp_invalid_code = /** @type {(inputs: Otp_Invalid_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il codice non è corretto. Controllalo e riprova.`)
};

/**
* | output |
* | --- |
* | "That code is not correct. Check it and try again." |
*
* @param {Otp_Invalid_CodeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const otp_invalid_code = /** @type {((inputs?: Otp_Invalid_CodeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Otp_Invalid_CodeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_otp_invalid_code(inputs)
	if (locale === "es-419") return es_419_otp_invalid_code(inputs)
	if (locale === "pt-PT") return pt_pt2_otp_invalid_code(inputs)
	if (locale === "fr-FR") return fr_fr2_otp_invalid_code(inputs)
	if (locale === "de-DE") return de_de2_otp_invalid_code(inputs)
	if (locale === "it-IT") return it_it2_otp_invalid_code(inputs)
	return en_us2_otp_invalid_code(inputs)
});
export { otp_invalid_code as "otp.invalid_code" }